import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminFetch, fmt } from "@/shop/api";

const STATUSES = [
  { id: "pending", label: "In attesa" },
  { id: "paid", label: "Pagato" },
  { id: "fulfilled", label: "Spedito" },
  { id: "cancelled", label: "Annullato" },
];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(null);

  const load = () =>
    adminFetch("/api/admin/orders")
      .then((r) => r.json())
      .then(setOrders)
      .catch(() => toast.error("Caricamento fallito"));

  useEffect(() => {
    load();
  }, []);

  const setStatus = async (number, status) => {
    await adminFetch(`/api/admin/orders/${number}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status }),
    });
    toast.success("Stato aggiornato");
    load();
  };

  return (
    <div data-testid="admin-orders">
      {orders.length === 0 && <p className="text-sm text-mist py-10">Nessun ordine per ora.</p>}
      <div className="space-y-2">
        {orders.map((o) => (
          <div key={o.number} data-testid={`order-row-${o.number}`} className="border border-ink-border bg-ink-surface">
            <button
              onClick={() => setOpen(open === o.number ? null : o.number)}
              className="w-full flex flex-wrap items-center gap-4 px-4 py-3.5 text-left"
            >
              <span className="font-mono text-xs text-ember">{o.number}</span>
              <span className="font-serif text-sm flex-1 min-w-[160px]">
                {o.first_name} {o.surname} — {o.items?.length || 0} oggetti
              </span>
              <span className="font-mono text-xs">{fmt(o.total)}</span>
              <select
                data-testid={`order-status-${o.number}`}
                value={o.status}
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => setStatus(o.number, e.target.value)}
                className="bg-ink border border-ink-border rounded-full px-3 py-1.5 font-mono text-[9px] uppercase tracking-[0.2em] text-mist"
              >
                {STATUSES.map((s) => (
                  <option key={s.id} value={s.id}>{s.label}</option>
                ))}
              </select>
            </button>
            {open === o.number && (
              <div className="border-t border-ink-border px-4 py-5 grid grid-cols-1 md:grid-cols-2 gap-6" data-testid={`order-detail-${o.number}`}>
                <div>
                  <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-faint mb-2">Oggetti</p>
                  {o.items?.map((i, idx) => (
                    <p key={idx} className="text-sm text-mist">
                      {i.brand} — {i.name} × {i.qty} <span className="font-mono text-bone">{fmt(i.price * i.qty)}</span>
                    </p>
                  ))}
                  <p className="mt-3 text-xs text-faint">Pagamento: {o.payment_status} · sessione {o.stripe_session_id?.slice(0, 20)}…</p>
                  {o.shipping_note && <p className="text-xs text-faint">Spedizione: {o.shipping_note}</p>}
                </div>
                <div className="text-sm text-mist">
                  <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-faint mb-2">Cliente</p>
                  <p>{o.email} {o.phone && `· ${o.phone}`}</p>
                  <p className="mt-1">
                    {o.address?.line1}, {o.address?.postal_code} {o.address?.city} ({o.country})
                  </p>
                  {o.vat_info && <p className="mt-1">P.IVA: {o.vat_info}</p>}
                  {o.notes && <p className="mt-1 italic">Note: {o.notes}</p>}
                  {o.newsletter_opt_in && <p className="mt-1 text-xs">Iscritto al Journal ✓</p>}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
